export let bannerBackgroundImageContainer;

/**
 *
 * @param {NodeListOf<Element>} sourceSets
 * @returns {*[]}
 */
function findClosestSourceSets(sourceSets) {
    let escapeOnNextIteration = false;
    let srcSet = [];
    for (const set of sourceSets) {
        if (set.dataset.width >= window.outerWidth) {
            if (escapeOnNextIteration) {
                srcSet['nextWidth'] = set.dataset.width;
                return srcSet;
            } else {
                srcSet['src'] = set.dataset.src;
                srcSet['width'] = set.dataset.width;
                escapeOnNextIteration = true;
            }
        }
        if (!escapeOnNextIteration) {
            srcSet['prevWidth'] = set.dataset.width;
        }
    }
    return srcSet;
}

export function initBannerBackgroundImageContainer() {
    const elements = document.querySelectorAll('.c3base-bannerBackgroundImage');
    for (const element of elements) {
        const imageContainer = element.querySelector('.c3base-bannerBackgroundImage-image-container');
        if (
            imageContainer &&
            (!imageContainer.dataset.currentSourceSet ||
                window.outerWidth <= parseInt(imageContainer.dataset.prvSourceSet) ||
                window.outerWidth >= parseInt(imageContainer.dataset.currentSourceSet))
        ) {
            const sourceSets = element.querySelectorAll('.image-data-container div');
            const resultSourceSet = findClosestSourceSets(sourceSets);
            imageContainer.style.backgroundImage = `url(${resultSourceSet['src']})`;
            imageContainer.dataset.currentSourceSet = resultSourceSet['width'];
            imageContainer.dataset.nextSourceSet = resultSourceSet['nextWidth'];
            imageContainer.dataset.prevSourceSet = resultSourceSet['prevWidth'];
        }
        bannerBackgroundImageContainer = true;
    }
}
